/* BAM Awwwards Pro v2 - extracted from snippets/bam-awwwards-pro.liquid 2026-08-26.
   Logic unchanged. Now loaded with defer instead of parsed inline in <head>.
   Self-contained IIFE, no globals exported, so load order is not significant.
   Note: cleanup() previously ran at inline-parse time; with defer it runs after
   parsing, but it also runs on DOMContentLoaded and at 500ms/1500ms, so the
   stale .bam-story removal behaviour is preserved. */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var isTouch = ('ontouchstart' in window) && navigator.maxTouchPoints > 0;

  /* ===== Mouse spotlight on dark sections ===== */
  function setupSpotlight(){
    if (isTouch) return;
    var hosts = document.querySelectorAll(
      'footer, .bam-trust-strip, [class*="hero"][style*="2B2A26"]'
    );
    hosts.forEach(function(host){
      if (host.dataset.bamSpot === '1') return;
      host.dataset.bamSpot = '1';
      host.classList.add('bam-spotlight-host');
      var sp = document.createElement('div');
      sp.className = 'bam-spotlight';
      host.appendChild(sp);
      host.addEventListener('mousemove', function(e){
        var rect = host.getBoundingClientRect();
        var mx = ((e.clientX - rect.left) / rect.width) * 100;
        var my = ((e.clientY - rect.top) / rect.height) * 100;
        host.style.setProperty('--mx', mx + '%');
        host.style.setProperty('--my', my + '%');
        host.classList.add('is-hover');
      });
      host.addEventListener('mouseleave', function(){
        host.classList.remove('is-hover');
      });
    });
  }

  /* ===== Nav image peek on brand link hover ===== */
  var BRAND_IMAGES = {
    'bella-canvas':   { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/85510_f_fm_580b4e45-6365-4343-929c-73ae7b032048.jpg', label: 'BELLA + CANVAS' },
    'next-level':     { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/79906_f_fm_c83ad626-be07-4f4c-afe0-49df18e5d870.jpg', label: 'Next Level' },
    'gildan-1':       { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/19557_f_fm.jpg', label: 'Gildan' },
    'comfort-colors': { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/107736_f_fm.jpg', label: 'Comfort Colors' },
    'core365':        { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/118872_f_fm.jpg', label: 'CORE365' },
    't-shirts':       { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/45904_f_fm.jpg', label: 'T-Shirts' },
    'polos':          { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/118872_f_fm.jpg', label: 'Polos' },
    'sweatshirts':    { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/107736_f_fm.jpg', label: 'Sweatshirts' },
    'hoodies':        { url: 'https://cdn.shopify.com/s/files/1/0735/2687/0106/files/107750_f_fm.jpg', label: 'Hoodies' }
  };
  function setupNavPeek(){
    if (isTouch) return;
    var peek = document.createElement('div');
    peek.className = 'bam-peek';
    peek.innerHTML = '<img alt=""><div class="bam-peek__label"></div>';
    document.body.appendChild(peek);
    var peekImg = peek.querySelector('img');
    var peekLabel = peek.querySelector('.bam-peek__label');
    var peekTimer = null;
    function findBrand(href){
      if (!href) return null;
      for (var slug in BRAND_IMAGES) {
        if (href.indexOf('/' + slug) !== -1) return BRAND_IMAGES[slug];
      }
      return null;
    }
    document.addEventListener('mouseover', function(e){
      var a = e.target.closest('header a[href*="/collections/"], header-component a[href*="/collections/"]');
      if (!a) return;
      var brand = findBrand(a.getAttribute('href'));
      if (!brand) return;
      peekImg.src = brand.url;
      peekLabel.textContent = brand.label;
      clearTimeout(peekTimer);
      peekTimer = setTimeout(function(){ peek.classList.add('is-visible'); }, 80);
    });
    document.addEventListener('mousemove', function(e){
      if (!peek.classList.contains('is-visible')) return;
      var x = e.clientX + 24;
      var y = e.clientY + 24;
      if (x + 230 > window.innerWidth) x = e.clientX - 240;
      if (y + 290 > window.innerHeight) y = e.clientY - 296;
      peek.style.left = x + 'px';
      peek.style.top = y + 'px';
    });
    document.addEventListener('mouseout', function(e){
      var a = e.target.closest('header a[href*="/collections/"], header-component a[href*="/collections/"]');
      if (!a) return;
      clearTimeout(peekTimer);
      peek.classList.remove('is-visible');
    });
  }

  function init(){ setupSpotlight(); setupNavPeek(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', setupSpotlight);

  /* Aggressively remove any stale sticky-scroll story sections that earlier versions injected */
  function cleanup(){
    document.querySelectorAll('.bam-story').forEach(function(el){ el.remove(); });
  }
  cleanup();
  document.addEventListener('DOMContentLoaded', cleanup);
  setTimeout(cleanup, 500);
  setTimeout(cleanup, 1500);
})();
